import { render } from "./restaurer.vue?vue&type=template&id=72fe52e7&scoped=true"
import script from "./restaurer.vue?vue&type=script&lang=js"
export * from "./restaurer.vue?vue&type=script&lang=js"

import "../../../assets/css/modal.css?vue&type=style&index=0&id=72fe52e7&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fe52e7"]])

export default __exports__